import { organisationConstants } from '../../_constants/organisation.constants';
const initialState = { enable_report_loading : true, enable_report: '', enable_report_error: false};

export function enableReports(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_ENABLE_REPORT:
        return {
            enable_report_loading: true,
            enable_report: '',
            enable_report_error: false
        };
      case organisationConstants.RESPONSE_ENABLE_REPORT:
        return {
            enable_report_loading: false,
            enable_report: action.enable_report,
            enable_report_error: false
        };
      case organisationConstants.ERROR_ENABLE_REPORT:
        return { 
            enable_report_loading: false,
            enable_report: '',
            enable_report_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/enableReport.reducer.js